<template>
  <div
    style="
      position: absolute;
      transform: rotate(-14deg);
      top: -9px;
      left: -6px;
      white-space: nowrap;
    "
  >
    <span
      style="font-size: 11px; padding: 3px 5px"
      :style="{
        color: this.fontColor,
        backgroundColor: this.backgroundColor,
        border: `3px solid ${this.fontColor}`,
      }"
    >
      {{ labelText }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'TopLeftQuadrangle',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    labelText () {
      return this.item.itemableAttributes.labelText
    },
    fontColor () {
      return this.item.itemableAttributes.backgroundColor
    },
    backgroundColor () {
      return this.item.itemableAttributes.fontColor
    }
  }
}
</script>
